// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"304":"3b45c70f","352":"0108f14c"}[chunkId] + ".chunk.js";
};